// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataBlock_NSlCH {
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-radius: var( --size-padMedium );
  background-color: var( --color-white );
  border-top-width: 1px;
  border-top-color: var( --color-base900 );
  border-left-width: 1px;
  border-left-color: var( --color-base900 );
  border-right-width: 1px;
  border-right-color: var( --color-base900 );
  border-bottom-width: 1px;
  border-bottom-color: var( --color-base900 );
}
.dataBlock_NSlCH .title__xW6W {
  font: bold 16px/24px Inter;
  color: var( --color-base700 );
  padding-top: 0px;
  padding-bottom: var( --size-padMedium );
}
.dataBlock_NSlCH .row_b3Bl4 {
  padding-top: var( --size-padLarge );
  border-bottom: 1px solid var( --color-base100 );
  padding-bottom: var( --size-padLarge );
}
.dataBlock_NSlCH .row_b3Bl4:last-child {
  padding-bottom: 0px;
  border-bottom-width: 0px;
}
.dataBlock_NSlCH .row_b3Bl4 .label_AXzU_ {
  font: 13px/20px Inter;
  color: var( --color-base500 );
}
.dataBlock_NSlCH .row_b3Bl4 .value_UPKdh {
  font: normal 600 15px/24px Inter;
  color: var( --color-base700 );
}
.dataBlock_NSlCH.dataBlock-secondary_R0R9B .row_b3Bl4 {
  gap: 0px;
  width: 33%;
  display: flex;
  margin-top: var( --size-medium );
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom-width: 0px;
}
.dataBlock_NSlCH.dataBlock-secondary_R0R9B .row_b3Bl4 .label_AXzU_ {
  margin-bottom: var( --size-medium );
}`, "",{"version":3,"sources":["webpack://./src/theme/DataBlock.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,sCAAsC;EACtC,sCAAsC;EACtC,qBAAqB;EACrB,wCAAwC;EACxC,sBAAsB;EACtB,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,wBAAwB;EACxB,2CAA2C;AAC7C;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,QAAQ;EACR,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,mCAAmC;AACrC","sourcesContent":[".dataBlock {\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-radius: var( --size-padMedium );\n  background-color: var( --color-white );\n  border-top-width: 1px;\n  border-top-color: var( --color-base900 );\n  border-left-width: 1px;\n  border-left-color: var( --color-base900 );\n  border-right-width: 1px;\n  border-right-color: var( --color-base900 );\n  border-bottom-width: 1px;\n  border-bottom-color: var( --color-base900 );\n}\n.dataBlock .title {\n  font: bold 16px/24px Inter;\n  color: var( --color-base700 );\n  padding-top: 0px;\n  padding-bottom: var( --size-padMedium );\n}\n.dataBlock .row {\n  padding-top: var( --size-padLarge );\n  border-bottom: 1px solid var( --color-base100 );\n  padding-bottom: var( --size-padLarge );\n}\n.dataBlock .row:last-child {\n  padding-bottom: 0px;\n  border-bottom-width: 0px;\n}\n.dataBlock .row .label {\n  font: 13px/20px Inter;\n  color: var( --color-base500 );\n}\n.dataBlock .row .value {\n  font: normal 600 15px/24px Inter;\n  color: var( --color-base700 );\n}\n.dataBlock.dataBlock-secondary .row {\n  gap: 0px;\n  width: 33%;\n  display: flex;\n  margin-top: var( --size-medium );\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  border-bottom-width: 0px;\n}\n.dataBlock.dataBlock-secondary .row .label {\n  margin-bottom: var( --size-medium );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataBlock": `dataBlock_NSlCH`,
	"title": `title__xW6W`,
	"row": `row_b3Bl4`,
	"label": `label_AXzU_`,
	"value": `value_UPKdh`,
	"dataBlock-secondary": `dataBlock-secondary_R0R9B`
};
export default ___CSS_LOADER_EXPORT___;
